module.exports = __webpack_public_path__ + "img/bn.4ebb0df9.svg";